import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const PHONE = "32466324304"; // +32 466 32 43 04 (BE format for wa.me)
const MESSAGE = "Hallo, ik wil graag een offerte voor schoonmaakdiensten.";
const WA_URL = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;

const WhatsAppIcon = ({ size = 28 }) => (
  <svg
    viewBox="0 0 32 32"
    width={size}
    height={size}
    aria-hidden="true"
    fill="currentColor"
  >
    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.93 2.722.93.515 0 2.18-.43 2.378-.974.075-.187.107-.366.107-.547.001-.66-.99-1.05-1.476-1.05ZM16.077 8c-4.466 0-8.077 3.51-8.077 7.85 0 1.485.435 2.905 1.246 4.143l-1.642 4.794 5.062-1.602a8.281 8.281 0 0 0 3.411.732c4.467 0 8.077-3.51 8.077-7.85S20.544 8 16.077 8Zm0 14.4a6.78 6.78 0 0 1-3.366-.892l-2.405.766.787-2.281a6.34 6.34 0 0 1-1.121-3.65c0-3.515 2.733-6.405 6.105-6.405 3.373 0 6.105 2.89 6.105 6.405 0 3.515-2.732 6.05-6.105 6.05Z" />
  </svg>
);

export const WhatsAppFloat = () => {
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setOpen(true), 4000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3" data-testid="whatsapp-float">
      {open && !dismissed && (
        <div className="relative max-w-[280px] rounded-2xl bg-white shadow-2xl border border-slate-200 p-4 animate-in fade-in slide-in-from-bottom-2 duration-300">
          <button
            type="button"
            onClick={() => setDismissed(true)}
            aria-label="Sluiten"
            data-testid="whatsapp-bubble-close"
            className="absolute -top-2 -right-2 inline-flex h-6 w-6 items-center justify-center rounded-full bg-slate-900 text-white shadow"
          >
            <X size={12} />
          </button>
          <div className="flex items-start gap-3">
            <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#25D366] text-white">
              <WhatsAppIcon size={18} />
            </span>
            <div>
              <p className="font-display font-bold text-sm text-[#0F172A] leading-tight">
                Vraag uw offerte via WhatsApp
              </p>
              <p className="text-xs text-slate-500 mt-1">
                Snel antwoord, meestal binnen enkele minuten.
              </p>
            </div>
          </div>
          <a
            href={WA_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-bubble-cta"
            className="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1FB857] text-white text-sm font-semibold px-4 py-2.5 transition-colors"
          >
            <WhatsAppIcon size={16} />
            Start gesprek
          </a>
        </div>
      )}

      <a
        href={WA_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Open WhatsApp"
        data-testid="whatsapp-float-btn"
        className="group relative inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-2xl shadow-emerald-300/60 hover:bg-[#1FB857] hover:-translate-y-0.5 hover:shadow-emerald-400/60 transition-all"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" />
        <span className="relative">
          <WhatsAppIcon size={28} />
        </span>
      </a>
    </div>
  );
};
